<div class="identify-toggle">
    <div class="instructions">
        <span>Check the layers you want to display in the identify pop-up window.</span>
    </div>
    <div class=" check-all">
        <a (click)="setAll(true)" title="All layers on.">Check All</a> &nbsp;
        <a (click)="setAll(false)" title="All layers off.">Uncheck All</a>
    </div>
    <div class="layers">
        <div class="layer" *ngFor="let layer of layers">
            <input type="checkbox" title="Toggle Identify On/Off" [(ngModel)]="layer.mapcoreProps.identifyEnabled">
            <span class="name">{{ layer.mapcoreProps.name }}</span>
        </div>
    </div>
    <div class="close-button">
        <button class="btn" (click)="close()">Close</button>
    </div>
</div>
